import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { updateConfigPtMonDigital } from "./services";

const initialState: any = {
  status: "",
  data: null,
};

export const actionUpdateConfigPtMonDigital: any = createAsyncThunk<any, any>(
  "ACTION_UPDATE_CONFIG_PT_MON_DIGITAL",
  async (data, { getState }: any) => {
    const {
      getLojas: { lojaSelected },
      getPtMonDigital,
    } = getState();
    const result = await updateConfigPtMonDigital(getPtMonDigital.data.id, {
      ...data,
      idLoja: lojaSelected,
    });
    return result.data;
  }
);

const sliceUpdateConfigPtMonDigital = createSlice({
  name: "UPDATE_CONFIG",
  initialState,
  reducers: {
    actionResetStateUpdadePtMonDigital: (state) => {
      state.status = "";
      state.msgError = "";
    },
  },
  extraReducers: {
    [actionUpdateConfigPtMonDigital.pending]: (state) => {
      state.status = "loading";
    },
    [actionUpdateConfigPtMonDigital.fulfilled]: (state, { payload }) => {
      state.status = "success";
      state.data = payload;
    },
    [actionUpdateConfigPtMonDigital.rejected]: (
      state,
      { error: { message } }
    ) => {
      state.status = "error";
      state.msgError = message;
    },
  },
});

export default sliceUpdateConfigPtMonDigital.reducer;
export const { actionResetStateUpdadePtMonDigital } =
  sliceUpdateConfigPtMonDigital.actions;
